"use client"

import { useEffect } from "react"

export function ChangeBodyColor(props: { color: string }) {
  useEffect(() => {
    document.body.style.backgroundColor = props.color
  }, [props.color])
  return null
}
